import _ from 'lodash';

import { useLocales as getLocales } from 'src/locales';

// ----------------------------------------------------------------------

function getLocaleCode() {
  const {
    currentLang: {
      numberFormat: { code, currency },
    },
  } = getLocales();

  return {
    code: _.defaultTo(code, 'fr-FR'),
    currency: _.defaultTo(currency, 'EUR'),
  };
}

// ----------------------------------------------------------------------

export function fNumber(
  inputValue,
  minimumFractionDigits = 0,
  maximumFractionDigits = 2,
  returnString = true
) {
  const { code } = getLocaleCode();

  if (_.isEmpty(inputValue) && !_.isNumber(inputValue)) {
    return '';
  }

  const number = _.chain(inputValue).toString().replace(',', '.').thru(_.toNumber).value();

  if (!_.isFinite(number)) {
    return '';
  }

  if (!returnString) {
    return number;
  }

  return new Intl.NumberFormat(code, {
    minimumFractionDigits,
    maximumFractionDigits,
    useGrouping: false,
  }).format(number);
}

export function fixedNumber(inputValue, returnString = false) {
  return fNumber(inputValue, undefined, undefined, returnString);
}

// ----------------------------------------------------------------------

export function fData(inputValue) {
  if (_.isEmpty(inputValue) && !_.isNumber(inputValue)) {
    return '';
  }

  if (_.isEqual(inputValue, 0)) {
    return '0 Bytes';
  }

  const units = ['bytes', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'];
  const number = _.toNumber(inputValue);

  if (!_.isFinite(number)) {
    return '';
  }

  const index = _.floor(Math.log(number) / Math.log(1024));
  const value = _.round(number / 1024 ** index, 2);

  return `${value} ${_.get(units, index, 'bytes')}`;
}
